import { apiContract } from '@retro-ui/api-contract';
import { ApiFetcherArgs, initClient, tsRestFetchApi } from '@ts-rest/core';
import { initQueryClient } from '@ts-rest/react-query';

const baseUrl = `${window.location.origin}/internal`;

const clientArgs = {
  baseUrl,
  baseHeaders: {},
  credentials: 'include' as RequestCredentials,
  api: async (args: ApiFetcherArgs & { redirectUnauthorized?: boolean }) => {
    const { redirectUnauthorized = true, ...fetchArgs } = args;
    const result = await tsRestFetchApi(fetchArgs);

    if (redirectUnauthorized && result.status === 401) {
      window.location.assign(`${baseUrl}/auth/sign-in?from=${window.location.href}`);
    }

    return result;
  },
};

export const apiClient = initClient(apiContract, clientArgs);

export const apiQueryClient = initQueryClient(apiContract, clientArgs);
